










































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/customer-header.vue";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import { GetPaperList, GetPaperEcharts } from "@/request/common";
import Literature from "../components/literature.vue";
import Fankui from "@/components/fankui.vue";
@Component({
  components: {
    MainHeader,
    Literature,
    Fankui,
  },
})
export default class Name extends mixins(listMixin) {
  private leftType: any = [];
  private echartsData: any = {};
  private data: any = [];
  private ifShowEcharts: any = false;
  private showFankui: any = false;
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private openFankui() {
    this.showFankui = true;
  }
  private goDetail(item: any) {
    this.$router.push({
      path: "/main/knowledge/extract-detail",
      query: {
        id: item.id,
      },
    });
  }
  private openEcharts(item: any) {
    const obj: any = {
      search_key: this.filters.type,
      search_value: this.filters.search,
      dimension: item.value,
    };
    this.echartsData = obj;
    this.ifShowEcharts = true;
  }
  private changeExpand(item: any, val: any) {
    item.expand = val;
    this.$forceUpdate();
  }
  private changeOpen(items: any, val: any) {
    if (val) {
      if (!items.data || !items.data.data) {
        this.getOptions(items).then((res: any) => {
          items.data = res;
          items.open = val;
          console.log(items);
          this.$forceUpdate();
        });
      }
    }
    items.open = val;
    this.$forceUpdate();
  }
  private getOptions(item: any) {
    return new Promise((resolve, reject) => {
      const params: any = {
        params: {
          search_key: this.filters.type,
          search_value: this.filters.search,
          dimension: item.value,
        },
      };
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      GetPaperEcharts(this, params, loading)
        .then((res: any) => {
          resolve(res.data);
        })
        .catch(() => {
          reject();
        });
    });
  }
  private goSearch() {
    this.getLeftData();
    this.filters["关键词"] = [];
    this.filters["发表年份"] = [];
    this.filters["民族医药种类"] = [];
    this.filters["疾病"] = [];
    this.filters["期刊"] = [];
    this.filters["作者"] = [];
    this.filters["发文地区"] = [];
    this.$forceUpdate();
    this.search();
  }
  private getLeftData() {
    this.leftType = [
      {
        name: "关键词",
        value: "关键词",
        ifOpen: false,
        expand: false,
        data: [],
      },
      {
        name: "发表年份",
        value: "发表年份",
        ifOpen: false,
        expand: false,
        data: [],
      },
      {
        name: "民族医药种类",
        value: "民族医药种类",
        ifOpen: false,
        expand: false,
        data: [],
      },
      {
        name: "疾病",
        value: "疾病",
        ifOpen: false,
        expand: false,
        data: [],
      },
      {
        name: "期刊",
        value: "期刊",
        ifOpen: false,
        expand: false,
        data: [],
      },
      {
        name: "作者",
        value: "作者",
        ifOpen: false,
        expand: false,
        data: [],
      },
      {
        name: "发文地区",
        value: "发文地区",
        ifOpen: false,
        expand: false,
        data: [],
      },
    ];
  }
  getList() {
    console.log(this.filters);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        ordering: this.filters.ordering,
        page: this.filters.current_page,
        limit: 10,
        search_key: this.filters.type,
        search_value: this.filters.search,
      },
    };
    if (this.filters["关键词"] && this.filters["关键词"].length > 0) {
      params.params["关键词"] = this.filters["关键词"].join(",");
    }
    if (this.filters["发表年份"] && this.filters["发表年份"].length > 0) {
      params.params["发表年份"] = this.filters["发表年份"].join(",");
    }
    if (
      this.filters["民族医药种类"] &&
      this.filters["民族医药种类"].length > 0
    ) {
      params.params["民族医药种类"] = this.filters["民族医药种类"].join(",");
    }
    if (this.filters["疾病"] && this.filters["疾病"].length > 0) {
      params.params["疾病"] = this.filters["疾病"].join(",");
    }
    if (this.filters["期刊"] && this.filters["期刊"].length > 0) {
      params.params["期刊"] = this.filters["期刊"].join(",");
    }
    if (this.filters["作者"] && this.filters["作者"].length > 0) {
      params.params["作者"] = this.filters["作者"].join(",");
    }
    if (this.filters["发文地区"] && this.filters["发文地区"].length > 0) {
      params.params["发文地区"] = this.filters["发文地区"].join(",");
    }
    localStorage.setItem(
      "literatureFolderFilter",
      JSON.stringify(this.filters)
    );
    GetPaperList(this, params, loading).then((res: any) => {
      this.data = res.data;
      this.filters.total_count = res.total;
      if (this.data.length > 0) {
        this.ifShowEmpty = false;
      } else {
        this.ifShowEmpty = true;
      }
    });
  }
  mounted() {
    if (localStorage.getItem("literatureFolderFilter")) {
      this.filters = JSON.parse(
        localStorage.getItem("literatureFolderFilter") as any
      );
    }
    if (!this.filters.type) {
      this.filters.type = "标题";
    }
    if (!this.filters["关键词"]) {
      this.filters["关键词"] = [];
    }
    if (!this.filters["发表年份"]) {
      this.filters["发表年份"] = [];
    }
    if (!this.filters["民族医药种类"]) {
      this.filters["民族医药种类"] = [];
    }
    if (!this.filters["疾病"]) {
      this.filters["疾病"] = [];
    }
    if (!this.filters["期刊"]) {
      this.filters["期刊"] = [];
    }
    if (!this.filters["作者"]) {
      this.filters["作者"] = [];
    }
    if (!this.filters["发文地区"]) {
      this.filters["发文地区"] = [];
    }
    this.getList();
    this.getLeftData();
  }
}
